import type { QuestionMatchingData, AnswerQuestionMatchingAnswer } from '@repo/types/questions/QuestionMatching';

import { QuestionMatchingAnswer } from '@/components/features/quiz/question/question-resolver/question-matching';

interface QuestionMarkedMatchingContentProps {
  question: QuestionMatchingData;
}

export function QuestionMarkedMatchingContent(questionMarkedMatchingContentProps: QuestionMarkedMatchingContentProps) {
  const { question } = questionMarkedMatchingContentProps;
  if (!question.answers) {
    return null;
  }

  const left: AnswerQuestionMatchingAnswer[] = [];
  const right: AnswerQuestionMatchingAnswer[] = [];

  question.answers.forEach((pair) => {
    left.push(pair.left);
    right.push(pair.right);
  });

  const columns = [left, right];

  return (
    <div className="space-y-2">
      {columns.map((column, index) => (
        <div key={index} className="grid grid-cols-[1fr_1fr] gap-1.5">
          {column.map((answer) => (
            <QuestionMatchingAnswer key={answer.id} content={answer.content} isSelected={false} isDisabled={false} pairNumber={null} className="cursor-default" />
          ))}
        </div>
      ))}
    </div>
  );
}
